'use strict';
import { tns } from "tiny-slider"

class PageListCarousel {
    constructor() {
        const sliders = [...document.querySelectorAll('.event-subjects__list')];
        if (sliders) {
            sliders.forEach((slider) => {
                const hasThreeItems = slider.classList.contains('event-subjects__list--grid');
                tns({
                    container: slider,
                    slideBy: "page",
                    autoplay: false,
                    controls: true,
                    autoWidth: true,
                    nav: false,
                    speed: 250,
                    mouseDrag: true,
                    gutter: 16,
                    controlsText: ['', ''],
                    loop: false,
                    onInit: function (instance) {
                        instance.nextButton.ariaLabel = "Framåt";
                        instance.prevButton.ariaLabel = "Bakåt";
                    },
                    responsive: {
                        768: {
                            autoWidth:true,
                            gutter: 16,
                            items: 6,
                        },
                    },
                    controlsContainer: slider.closest('.event-subjects').querySelector('.event-subjects__controls')
                });
            })

        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new PageListCarousel();
});
